export class DataCatalogTagConjunction {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allOf",
            "baseName": "allOf",
            "type": "Array<DataCatalogTagPredicate>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogTagConjunction.attributeTypeMap;
    }
    constructor() {
    }
}
